define([
   	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/_base/underscore",
	"csi",
	"csi/table/AggregateFrom",
	"csi/xml"
], function(array,declare,lang,_,csi,AggregateTable,xml) {

	return declare(AggregateTable, {
		preProcess: function() {
			// summary: do not allow action if quote doesn't have a bom
			var group = this.getParent();
			// fetch the quote fresh to ensure someone else hasn't changed it
			var quoteRev = this.m_cache.getPathNode(this.getParent(), "Child:__Parent__/Child:__Parent__");
			if (!xml.isValidURL(quoteRev.QuoteBOM)) {
				this.displayErrorDialog({suffix:"_ErrorHasNoBOM"});
			} else if (!xml.isValidURL(quoteRev.QuoteBOMRevision)) {
				this.displayErrorDialog({suffix:"_ErrorNoQuoteBOMRevision"});
			} else {
				this.inherited(arguments);
			}
		},

		getFormData: function() {
			var fd = this.inherited(arguments);
			var group = this.getParent();
			var quoteRev = this.m_cache.getNode(this.m_cache.getNode(group.__Parent__).__Parent__);
			if (quoteRev.ProductSizes.length != 1 && quoteRev.Colors.length == 1) {
				fd.m_fAggregateTest = lang.hitch(this, this._canAggregateElementColors);
			} else if (quoteRev.ProductSizes.length == 1 && quoteRev.Colors.length != 1) {
				fd.m_fAggregateTest = lang.hitch(this, this._canAggregateElementSizes);
			} else if (quoteRev.ProductSizes.length == 1 && quoteRev.Colors.length == 1) {
				fd.m_fAggregateTest = lang.hitch(this, this._canAggregateElementBoth);
			}
			return fd;
		},

		_canAggregateElementColors: function(/*Context*/ctx, /*FormData*/fd) {
			// summary: disallow the aggregation of the BOM line if all of the owning quote's colors are hidden
			var onlyForColors = ctx.getNode().OnlyForColors;
			if (!onlyForColors.length) {
				return true;
			}

			var group = this.getParent();
			var quoteRev = ctx.cache.getPathNode(group, "Child:__Parent__/Child:__Parent__", true);
			if (!quoteRev.Colors || !quoteRev.Colors.length)
				return true;

			return _.contains(onlyForColors, quoteRev.Colors[0]);
		},

		_canAggregateElementSizes: function(/*Context*/ctx, /*FormData*/fd) {
			// summary: disallow the aggregation of the BOM line if all of the owning quote's size not in OnlyForSizes of PartMaterial
			var onlyForSizes = ctx.getNode().OnlyForSizes;
			if (!onlyForSizes.length) {
				return true;
			}

			var group = this.getParent();
			var quoteRev = ctx.cache.getPathNode(group, "Child:__Parent__/Child:__Parent__", true);
			if (!quoteRev.ProductSizes || !quoteRev.ProductSizes.length)
				return true;

			return _.contains(onlyForSizes, quoteRev.ProductSizes[0]);
		},

		_canAggregateElementBoth: function(/*Context*/ctx, /*FormData*/fd) {
			// summary: disallow the aggregation of the BOM line if all of the owning quote's colors are hidden
			// and owning quote's size not in OnlyForSizes of PartMaterial
			var onlyForColors = ctx.getNode().OnlyForColors;
			var onlyForSizes = ctx.getNode().OnlyForSizes;
			if (!onlyForSizes.length && !onlyForColors.length) {
				return true;
			}
			var group = this.getParent();
			var quoteRev = ctx.cache.getPathNode(group, "Child:__Parent__/Child:__Parent__", true);
			if (quoteRev.ProductSizes.length != 1 && quoteRev.Colors.length != 1) {
				return true;
			}

			return (!onlyForSizes.length  || _.contains(onlyForSizes, quoteRev.ProductSizes[0])) &&
			       (!onlyForColors.length || _.contains(onlyForColors, quoteRev.Colors[0]));
		}
 	});
});